import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Every page starts at the top. This used to live inside the Footer, so it
// only worked on pages that rendered one — now it's router-wide, and the
// Footer only appears on Home.
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export default ScrollToTop;
